import fpApiUtil from "@plannel/services/fp/fp-api-util";

// old `simulationcompare/SimulationCompare.jsx`가 호출하던 엔드포인트 묶음.
// 백엔드는 `SimulationController`의 `simulation-compare/*` + `SimulationCompareService`(이관 완료).
const BASE = "factoryplan/simulation/simulation-compare";

/**
 * 계획수립일의 버전 목록. 응답은 **메인버전 그룹 Map**이다:
 *   { "<mainVersionCd> : <메인버전 설명>": [PlanVersionDto, ...] }
 * 키 문자열은 `SimulationCompareService.getVersions`가 조립한 것이라 화면에서 다시 만들지 않는다.
 * 각 PlanVersionDto에 `plants`(VersionPlantDto[])까지 채워져 온다(딥링크 payload에 필요).
 * params: { planScope, planningDate: "yyyyMMdd" }
 */
const getVersions = (params) => fpApiUtil.postParams(`${BASE}/versions`, params);

// KPI 5종. 전부 params { planScope, versionCds: string[] }를 받고, 응답 배열은
// `getSortedVersionCds()`가 만드는 **versionSeq 내림차순**으로 정렬돼 있다 —
// 화면도 같은 순서로 정렬해서 인덱스로 매핑한다(old 동일).
// 응답의 `dtos`(버전별 상세)는 old·new 프론트 모두 사용하지 않는다.
const getFulfillRate = (params) => fpApiUtil.postParams(`${BASE}/ful-fill-rate`, params);        // { labels[], data[] }
const getOnTimeRate = (params) => fpApiUtil.postParams(`${BASE}/on-time-rate`, params);          // { labels[], data[] }
const getLeadTime = (params) => fpApiUtil.postParams(`${BASE}/lead-time`, params);               // { labels[], data[] }
const getResourceUtilization = (params) => fpApiUtil.postParams(`${BASE}/resource-utilization`, params); // { labels[], data[] }
const getJobChange = (params) => fpApiUtil.postParams(`${BASE}/job-change`, params);             // { labels[], jcTmSumData[], jcCntSumData[] }

/**
 * 계획 확정. 같은 (mainVersionCd, stepCd, stepSeq)의 기존 확정 버전을 해제하고 이 버전을 확정한 뒤
 * 확정 계획(tb_fp_confirmed_plan)을 다시 적재한다.
 * params: { planScope, versionCd, userNm }  → 응답 ResponseMessage { message }
 * `confirmedBy`가 사용자 **id가 아니라 이름 문자열**이라 userNm을 같이 보낸다(01_fp_ddl.sql 컨벤션 예외).
 */
const confirmVersion = (params) => fpApiUtil.postParams(`${BASE}/confirm`, params);

const fpSimulationCompareService = {
  getVersions,
  getFulfillRate,
  getOnTimeRate,
  getLeadTime,
  getResourceUtilization,
  getJobChange,
  confirmVersion
};

export default fpSimulationCompareService;
